module.exports = __webpack_public_path__ + "static/dos-006e8a501aa69a56ebae8cc531e9bfc3.jpg";